export default __webpack_public_path__ + "static/media/disappointed.4da7ebea.svg";